/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResultCe } from './ResultCe';
import {
    ResultCeFromJSON,
    ResultCeFromJSONTyped,
    ResultCeToJSON,
} from './ResultCe';

/**
 * 
 * @export
 * @interface CalcCeResult
 */
export interface CalcCeResult {
    /**
     * ステータス
     * @type {string}
     * @memberof CalcCeResult
     */
    status?: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof CalcCeResult
     */
    message?: string;
    /**
     * Excel最終行
     * @type {number}
     * @memberof CalcCeResult
     */
    excelLastRow?: number;
    /**
     * 電解槽名
     * @type {string}
     * @memberof CalcCeResult
     */
    electrolyzer?: string;
    /**
     * 全体平均
     * @type {number}
     * @memberof CalcCeResult
     */
    averageCe?: number;
    /**
     * 係数セットID
     * @type {string}
     * @memberof CalcCeResult
     */
    coefficientSetId?: string;
    /**
     * 係数セット表示名
     * @type {string}
     * @memberof CalcCeResult
     */
    coefficientSetDisplayName?: string;
    /**
     * 計算結果
     * @type {Array<ResultCe>}
     * @memberof CalcCeResult
     */
    resultListCe?: Array<ResultCe>;
}

/**
 * Check if a given object implements the CalcCeResult interface.
 */
export function instanceOfCalcCeResult(value: object): value is CalcCeResult {
    return true;
}

export function CalcCeResultFromJSON(json: any): CalcCeResult {
    return CalcCeResultFromJSONTyped(json, false);
}

export function CalcCeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcCeResult {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
        'excelLastRow': json['excelLastRow'] == null ? undefined : json['excelLastRow'],
        'electrolyzer': json['electrolyzer'] == null ? undefined : json['electrolyzer'],
        'averageCe': json['averageCe'] == null ? undefined : json['averageCe'],
        'coefficientSetId': json['coefficientSetId'] == null ? undefined : json['coefficientSetId'],
        'coefficientSetDisplayName': json['coefficientSetDisplayName'] == null ? undefined : json['coefficientSetDisplayName'],
        'resultListCe': json['resultListCe'] == null ? undefined : ((json['resultListCe'] as Array<any>).map(ResultCeFromJSON)),
    };
}

export function CalcCeResultToJSON(value?: CalcCeResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'message': value['message'],
        'excelLastRow': value['excelLastRow'],
        'electrolyzer': value['electrolyzer'],
        'averageCe': value['averageCe'],
        'coefficientSetId': value['coefficientSetId'],
        'coefficientSetDisplayName': value['coefficientSetDisplayName'],
        'resultListCe': value['resultListCe'] == null ? undefined : ((value['resultListCe'] as Array<any>).map(ResultCeToJSON)),
    };
}

